var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.click}},[_c('span',{staticClass:"hora"},[_vm._v(_vm._s(_vm.parseDate(_vm.row[_vm.column.field])))]),_c('span',{staticClass:"periodo-name"},[_vm._v(_vm._s(_vm.periodoNome(_vm.row[_vm.column.field])))])])
}
var staticRenderFns = []

export { render, staticRenderFns }